module.exports = "/_next/static/images/284f7fc56b8c6dd979cc0f8a716818a0-rewards-app-lg@1x.png.webp";